import api from './axiosInstance';
import { BASE_URL } from './config';

export const fetchMethods = () =>
    api.get(`${BASE_URL}/partner-method`);

export const createMethod = (data) =>
    api.post(`${BASE_URL}/partner-method`, data);

export const updateMethod = (data) =>
    api.put(`${BASE_URL}/partner-method`, data);

export const deleteMethod = (id) =>
    api.delete(`${BASE_URL}/partner-method/${id}`);
